module.exports = __webpack_public_path__ + "img/character-baby-happy.8f85d0c7.svg";